(function () {
  'use strict';

  var ROOT_SELECTOR = 'vcc-rolling-search[data-vcc-rolling-module-url]';
  var ENGINE_READY_TIMEOUT_MS = 20000;
  if (window.VCCRollingSearchBootstrap && typeof window.VCCRollingSearchBootstrap.scan === 'function') {
    window.VCCRollingSearchBootstrap.scan(document);
    return;
  }

  var observedRoots = new Set();
  var waitingEngineRoots = new Set();
  var enginePromise = null;
  var engineAttemptFinish = null;
  var ownedEngineScript = null;
  var ownedEngineScriptFailed = false;
  var modulePromise = null;
  var ownedModuleScript = null;
  var ownedModuleScriptFailed = false;
  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(onIntersection, { rootMargin: '350px 0px' })
    : null;

  function sameUrl(left, right) {
    try {
      return new URL(left, document.baseURI).href === new URL(right, document.baseURI).href;
    } catch (_error) {
      return left === right;
    }
  }

  function typedFailure(type, message, cause) {
    var error = new Error(message);
    error.vccBootstrapError = type;
    if (cause) error.cause = cause;
    return error;
  }

  function failureType(error, fallback) {
    return error && error.vccBootstrapError ? error.vccBootstrapError : fallback;
  }

  function onEngineReady() {
    if (!window.VCCSearchV4) return;

    if (engineAttemptFinish) engineAttemptFinish();

    var roots = Array.from(waitingEngineRoots);
    waitingEngineRoots.clear();
    roots.forEach(function (root) {
      if (!root || !root.isConnected || !observedRoots.has(root)) return;
      if (root.dataset.vccBootstrapState !== 'waiting-engine') return;
      activate(root);
    });
  }

  document.addEventListener('vcc:search-v4-ready', onEngineReady);

  function ensureV4Engine(url) {
    if (window.VCCSearchV4) return Promise.resolve(window.VCCSearchV4);
    if (enginePromise) return enginePromise;

    if (
      ownedEngineScriptFailed
      && ownedEngineScript
      && ownedEngineScript.isConnected
      && sameUrl(ownedEngineScript.src, url)
    ) {
      ownedEngineScript.remove();
      ownedEngineScript = null;
      ownedEngineScriptFailed = false;
    }

    enginePromise = new Promise(function (resolve, reject) {
      var settled = false;
      var timer = 0;

      function cleanup() {
        window.clearTimeout(timer);
        if (engineAttemptFinish === finish) engineAttemptFinish = null;
      }

      function finish(error) {
        if (settled) return;
        settled = true;
        cleanup();
        if (error) reject(error);
        else resolve(window.VCCSearchV4);
      }

      engineAttemptFinish = finish;
      timer = window.setTimeout(function () {
        if (window.VCCSearchV4) finish();
        else finish(typedFailure('engine-timeout', 'VCC Search V4 did not become ready.'));
      }, ENGINE_READY_TIMEOUT_MS);

      var existing = Array.prototype.find.call(document.scripts, function (script) {
        return script.src && sameUrl(script.src, url);
      });
      if (existing) {
        existing.addEventListener('error', function () {
          if (existing === ownedEngineScript) ownedEngineScriptFailed = true;
          finish(typedFailure('engine-load', 'VCC Search V4 failed to load.'));
        }, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.dataset.vccProductSearchV4 = '';
      ownedEngineScript = script;
      ownedEngineScriptFailed = false;
      script.addEventListener('error', function () {
        if (script === ownedEngineScript) ownedEngineScriptFailed = true;
        finish(typedFailure('engine-load', 'VCC Search V4 failed to load.'));
      }, { once: true });
      document.head.appendChild(script);
    }).catch(function (error) {
      enginePromise = null;
      throw error;
    });

    return enginePromise;
  }

  function ensureRollingModule(url) {
    if (customElements.get('vcc-rolling-search')) return Promise.resolve(true);
    if (modulePromise) return modulePromise;

    if (
      ownedModuleScriptFailed
      && ownedModuleScript
      && ownedModuleScript.isConnected
      && sameUrl(ownedModuleScript.src, url)
    ) {
      ownedModuleScript.remove();
      ownedModuleScript = null;
      ownedModuleScriptFailed = false;
    }

    modulePromise = new Promise(function (resolve, reject) {
      var settled = false;
      var timer = 0;
      var script = Array.prototype.find.call(document.scripts, function (candidate) {
        return candidate.type === 'module' && candidate.src && sameUrl(candidate.src, url);
      });

      function cleanup() {
        window.clearTimeout(timer);
        if (!script) return;
        script.removeEventListener('load', onLoad);
        script.removeEventListener('error', onError);
      }

      function finish(error) {
        if (settled) return;
        settled = true;
        cleanup();
        if (error) reject(error);
        else resolve(true);
      }

      function onLoad() {
        if (script === ownedModuleScript) script.dataset.vccRollingModuleState = 'loaded';
        if (!customElements.get('vcc-rolling-search')) {
          finish(typedFailure(
            'module-registration',
            'VCC rolling search module did not register its custom element.'
          ));
          return;
        }
        finish();
      }

      function onError() {
        if (script === ownedModuleScript) {
          ownedModuleScriptFailed = true;
          script.dataset.vccRollingModuleState = 'failed';
        }
        finish(typedFailure('module-import', 'VCC rolling search module failed to import.'));
      }

      if (script && script.dataset.vccRollingModuleState === 'loaded') {
        onLoad();
        return;
      }
      if (script && script.dataset.vccRollingModuleState === 'failed') {
        onError();
        return;
      }

      if (!script) {
        script = document.createElement('script');
        script.type = 'module';
        script.src = url;
        script.async = true;
        script.dataset.vccRollingModuleBootstrap = '';
        script.dataset.vccRollingModuleState = 'loading';
        ownedModuleScript = script;
        ownedModuleScriptFailed = false;
      }

      script.addEventListener('load', onLoad, { once: true });
      script.addEventListener('error', onError, { once: true });
      timer = window.setTimeout(function () {
        if (customElements.get('vcc-rolling-search')) finish();
        else finish(typedFailure('module-import', 'VCC rolling search module did not finish loading.'));
      }, ENGINE_READY_TIMEOUT_MS);
      if (!script.isConnected) document.head.appendChild(script);
    }).catch(function (error) {
      modulePromise = null;
      if (failureType(error, '')) throw error;
      throw typedFailure('module-import', 'VCC rolling search module failed to import.', error);
    });

    return modulePromise;
  }

  function clearFailureState(root) {
    if (!root) return;
    delete root.dataset.vccBootstrapError;
    if (root.dataset.state === 'unavailable') delete root.dataset.state;
    root.hidden = false;
  }

  function markWaitingEngine(root) {
    if (!root || !root.isConnected) return;
    root.dataset.vccBootstrapState = 'waiting-engine';
    root.dataset.ready = 'false';
    delete root.dataset.vccBootstrapError;
    if (root.dataset.state === 'unavailable') delete root.dataset.state;
    root.hidden = false;
    waitingEngineRoots.add(root);
  }

  function markUnavailable(root, error) {
    if (!root || !root.isConnected) return;
    root.dataset.vccBootstrapState = 'error';
    root.dataset.vccBootstrapError = failureType(error, 'unknown');
    root.dataset.ready = 'false';
    root.dataset.state = 'unavailable';
    root.hidden = true;
    waitingEngineRoots.delete(root);
    if (error && window.Shopify && window.Shopify.designMode) {
      console.error('[VCC rolling search bootstrap]', error);
    }
  }

  function activate(root) {
    if (
      !root
      || !root.isConnected
      || root.dataset.vccBootstrapState === 'loading'
      || root.dataset.vccBootstrapState === 'ready'
    ) return;

    waitingEngineRoots.delete(root);
    clearFailureState(root);
    root.dataset.vccBootstrapState = 'loading';
    if (observer) observer.unobserve(root);

    var mode = root.dataset.searchMode || 'legacy';
    var engineUrl = root.dataset.vccSearchV4Url || '';
    var moduleUrl = root.dataset.vccRollingModuleUrl || '';
    var engineReady = mode === 'v4_metafield' ? ensureV4Engine(engineUrl) : Promise.resolve(true);

    engineReady
      .then(function () {
        if (!root.isConnected) return false;
        return ensureRollingModule(moduleUrl);
      })
      .then(function (ready) {
        if (!ready || !root.isConnected) return;
        if (root.dataset.initialized !== 'true') {
          throw typedFailure('module-init', 'VCC rolling search custom element did not initialize.');
        }
        root.dataset.vccBootstrapState = 'ready';
        delete root.dataset.vccBootstrapError;
        root.hidden = false;
      })
      .catch(function (error) {
        if (!root.isConnected) return;
        if (failureType(error, '') === 'engine-timeout') {
          markWaitingEngine(root);
          return;
        }
        markUnavailable(root, error);
      });
  }

  function onIntersection(entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) activate(entry.target);
    });
  }

  function watch(root) {
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);
    if (window.Shopify && window.Shopify.designMode) {
      activate(root);
    } else if (observer) {
      observer.observe(root);
    } else {
      activate(root);
    }
  }

  function scan(scope) {
    var root = scope && scope.matches && scope.matches(ROOT_SELECTOR) ? scope : null;
    if (root) watch(root);
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll(ROOT_SELECTOR).forEach(watch);
  }

  function activateFromIntent(event) {
    var root = event.target && event.target.closest ? event.target.closest(ROOT_SELECTOR) : null;
    if (root) activate(root);
  }

  scan(document);
  window.VCCRollingSearchBootstrap = Object.freeze({ scan: scan, activate: activate });

  ['pointerover', 'pointerdown', 'focusin'].forEach(function (eventName) {
    document.addEventListener(eventName, activateFromIntent, true);
  });
  document.addEventListener('touchstart', activateFromIntent, { capture: true, passive: true });

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    var roots = [];
    if (event.target.matches && event.target.matches(ROOT_SELECTOR)) roots.push(event.target);
    event.target.querySelectorAll(ROOT_SELECTOR).forEach(function (root) { roots.push(root); });
    roots.forEach(function (root) {
      if (observer) observer.unobserve(root);
      waitingEngineRoots.delete(root);
      observedRoots.delete(root);
    });
  });
})();
